export default __webpack_public_path__ + "static/media/Energera_FullLogo_White.5aa20af7.png";